import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Reviews from "./pages/Reviews";
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/home"
            element={
                <Home />
            }
          />
          <Route
            path="/gallery"
            element={
                <Gallery />
            }
          />
           <Route
            path="/reviews"
            element={
                <Reviews />
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
